import { render, staticRenderFns } from "./Refunds.vue?vue&type=template&id=04c32cc4"
import script from "./Refunds.vue?vue&type=script&lang=js"
export * from "./Refunds.vue?vue&type=script&lang=js"
import style0 from "./Refunds.vue?vue&type=style&index=0&id=04c32cc4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports